import { tokens } from '../tokens/bosch-light';
export const boschLight = {
    tokens,
};
//# sourceMappingURL=bosch-light.js.map